<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Earning from "./earning";
import SupplierPerMonth from './supplierpermonth'
import PromotionChart from './promotionchart'
import PromotionGraph from './promotiongraph'
/**
 * Reporting component
 */
export default {
  page: {
    title: "Les Rapports",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout,SupplierPerMonth,Earning,PromotionChart,PromotionGraph },

    mounted(){
    this.getCurrentMonthAndYear()
  },
  data() {
    return {
      currentYear:null,
      currentMonth:null,
    };
  },


  methods: {
    getCurrentMonthAndYear(){
        var dt = new Date();
        this.currentMonth=dt.getMonth();
        this.currentYear  = dt.getFullYear();
    },

  }
};
</script>

<template>
  <Layout>

  <div class="row pt-4 pb-4">
    <div class="col-12">
      <div class="row">
        <div class="col-lg-6">
          <Earning :isMonthly="true" :currentMonth="new Date().getMonth()" :currentYear="new Date().getFullYear()"  />
        </div>

        <div class="col-lg-6">
          <Earning :isYearly="true" :currentMonth="new Date().getMonth()" :currentYear="new Date().getFullYear()" />
        </div>
      </div>
      <!-- <div class="row">
        
        <div class="col-xl-4  ">
          <Earning :isMonthly="true" />
          <Earning :isYearly="true"/>
        </div> 
      </div>-->

      <div class="row">
        <div class="col-sm-12">
          <SupplierPerMonth />
        </div>
      </div>
      <div class="col-xl-12  ">
            
        </div>


      <div class="row">
          <div class="col-xl-8 ">
          <PromotionChart />
        </div>
        <div class="col-xl-4">
          <PromotionGraph />
        </div>
      </div>
    </div>
  </div>
    



  </Layout>
</template>
